import { render, staticRenderFns } from "./DonutBreakdown.vue?vue&type=template&id=7254b9f4&scoped=true"
import script from "./DonutBreakdown.vue?vue&type=script&lang=js"
export * from "./DonutBreakdown.vue?vue&type=script&lang=js"
import style0 from "./DonutBreakdown.vue?vue&type=style&index=0&id=7254b9f4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7254b9f4",
  null
  
)

export default component.exports